export default "__VITE_ASSET__DIXg4nZd__"